var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaystore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.523438 2.15405V29.9701C0.523606 30.0305 0.539868 30.0894 0.570184 30.1396C0.6005 30.1898 0.643521 30.2289 0.693852 30.2521C0.744183 30.2753 0.799583 30.2816 0.853106 30.2701C0.90663 30.2585 0.955893 30.2298 0.994718 30.1874L14.08 16.0628L0.994718 1.93676C0.955893 1.89439 0.90663 1.86565 0.853106 1.85415C0.799583 1.84264 0.744183 1.84888 0.693852 1.87209C0.643521 1.8953 0.6005 1.93443 0.570184 1.98459C0.539868 2.03475 0.523606 2.0937 0.523438 2.15405ZM19.5665 10.2589L3.15928 0.253639L3.14905 0.247269C2.86641 0.0774 2.59784 0.500658 2.82932 0.746968L15.6907 14.3592L19.5665 10.2589ZM2.8306 31.3786C2.59784 31.625 2.86641 32.0482 3.15033 31.8783L3.16056 31.872L19.5665 21.8667L15.6907 17.765L2.8306 31.3786ZM26.19 14.2933L21.6083 11.5004L17.3003 16.0628L21.6083 20.6231L26.19 17.8323C27.4363 17.07 27.4363 15.0556 26.19 14.2933Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/playstore.873e45c9d65013010a5aedca90f3222b.svg";
export { ForwardRef as ReactComponent };